import api from './api';

export const userService = {
  // Dohvati sve korisnike
  getTenantUsers: async (query) => {
    const queryString = new URLSearchParams(query).toString();
    return await api.get(`/tenant-users?${queryString}`);
  },

  // Dohvati korisnika po ID-u
  getTenantUserById: async (id) => {
    return await api.get(`/users/${id}`);
  },

  // Obriši korisnika
  deleteTenantUser: async (userId, tenantId) => {
    return await api.deleteWithBody("/tenant-users", {userId, tenantId});
  },

  getTenantsForUser: async (query) => {
    const queryString = new URLSearchParams(query).toString();
    return await api.get(`/tenant-users/getTenantsForUser?${queryString}`);
  },

  // Odobri korisnika
  approveUser: async (userId, tenantId) => {
    return await api.post(`/tenant-users/approve-user`, {userId, tenantId});
  },

  // Odbaci korisnika
  rejectUser: async (userId, tenantId) => {
    return await api.post(`/tenant-users/reject-user`, {userId, tenantId});
  },
  
  // Ažuriraj korisnika
  updateUser: async (userId, tenantId, dontRequireConfirmation) => {
    return await api.put(`/tenant-users/${userId}`, { tenantId, dontRequireConfirmation });
  },

};

export default userService;


